import { render, staticRenderFns } from "./CertificateTemplate.vue?vue&type=template&id=2d7773b6&"
import script from "./CertificateTemplate.vue?vue&type=script&lang=js&"
export * from "./CertificateTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CertificateTemplate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports